
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', () => drawer.classList.toggle('is-open'));
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.faq-q');
    if(btn) btn.addEventListener('click', () => item.classList.toggle('is-open'));
  });

  document.querySelectorAll('[data-accordion]').forEach(item => {
    const btn = item.querySelector('.accordion-btn');
    if(btn) btn.addEventListener('click', () => item.classList.toggle('is-open'));
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const form = select.closest('form');
    if(!form) return;
    select.addEventListener('change', () => {
      const optionValues = Array.from(form.querySelectorAll('[data-variant-select]')).map(s => s.value);
      const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
      const match = variants.find(v => JSON.stringify(v.options) === JSON.stringify(optionValues));
      if(match){
        const idInput = form.querySelector('[name="id"]');
        if(idInput) idInput.value = match.id;
        const price = form.closest('.product-info')?.querySelector('[data-product-price]');
        if(price && match.price_formatted) price.textContent = match.price_formatted;
        const add = form.querySelector('[data-add-button]');
        if(add){
          add.disabled = !match.available;
          add.textContent = match.available ? 'Añadir al carrito' : 'Agotado';
        }
      }
    });
  });
});


/* JJ-EVERYDAY-CART-20261017: selección persistente mediante el carrito Shopify.
 * Solo afecta a los 16 modelos Everyday en el tema de pruebas.
 * Los descuentos y sus importes se calculan exclusivamente en Shopify, no en JS.
 */
document.addEventListener('DOMContentLoaded', function() {
  var everydayHandles = new Set("pendientes-ancla-dorados-minimalistas|pendientes-cruz-dorados-minimalistas|pendientes-cruz-dorados-minimalistas-modelo-recto|pendientes-de-aro-dorados-gruesos|pendientes-de-aro-dorados-minimalistas|pendientes-de-mariposa-dorados-texturizados|pendientes-de-mariposa-negros-y-dorados|pendientes-estrella-de-seis-puntas-dorados|pendientes-flor-dorados|pendientes-huella-de-perrito-dorados|pendientes-huella-de-perrito-plateados|pendientes-luna-dorados|pendientes-luna-plateados|pendientes-rayos-dorados|pendientes-rayos-plateados|pendientes-tres-estrellas-plateadas".split("|"));
  var panel = document.querySelector('[data-jj-everyday-selection]');
  var cards = Array.prototype.slice.call(document.querySelectorAll('article.product-card'));
  if (!panel && !cards.length) return;
  var form = panel ? document.querySelector('.jj-earrings-quickbuy__form form') : null;
  var button = panel ? panel.querySelector('[data-jj-everyday-panel-add]') : null;
  var currentHandle = panel ? panel.getAttribute('data-product-handle') : '';
  var currentStatus = panel ? panel.querySelector('[data-jj-everyday-current]') : null;
  var progress = panel ? panel.querySelector('[data-jj-everyday-progress]') : null;
  var busy = false;
  var selected = {};

  var css = document.createElement('style');
  css.textContent = '.jj-everyday-cart-panel{margin:12px 0 16px;padding:16px;border:1px solid #d9e5df;border-radius:14px;background:#f4faf6;color:#243c32;font:13px/1.5 Arial,sans-serif}.jj-everyday-cart-panel__title{display:block;font-size:17px;margin-bottom:7px}.jj-everyday-cart-panel__add{display:block;width:100%;min-height:48px;margin:14px 0 8px;padding:12px 16px;background:#285f43;color:#fff;border:0;border-radius:28px;font:bold 14px Arial,sans-serif;cursor:pointer}.jj-everyday-cart-panel__add:disabled{opacity:.55;cursor:not-allowed}.jj-everyday-cart-panel p{margin:6px 0}.jj-everyday-cart-panel__links{display:flex;gap:10px;flex-wrap:wrap;margin:13px 0 10px}.jj-everyday-cart-panel__links a{flex:1 1 150px;text-align:center;border:1px solid #2d6949;border-radius:30px;padding:10px 12px;color:#22563a!important;text-decoration:none;font-weight:700}.jj-everyday-cart-panel__links a:first-child{background:#276445;color:white!important}.jj-everyday-cart-panel small{display:block;font-size:11px;color:#62736b}.jj-everyday-picked-badge{position:absolute;top:10px;left:10px;z-index:4;border-radius:50px;background:#286244;color:#fff;padding:7px 11px;font:700 11px/1.2 Arial,sans-serif;box-shadow:0 2px 8px rgba(0,0,0,.15)}.jj-everyday-cart-panel [role=status]{min-height:20px}';
  document.head.appendChild(css);

  function pathFor(endpoint) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + (endpoint === 'cart.js' ? 'cart.js' : 'cart/' + endpoint);
  }

  function findHandle(anchor) {
    try {
      var url = new URL(anchor.href, location.href);
      return decodeURIComponent((url.pathname.split('/products/')[1] || '').split('/')[0]);
    } catch (err) {
      return '';
    }
  }

  function updateBadges() {
    cards.forEach(function(card) {
      var anchor = card.querySelector('a[href*="/products/"]');
      if (!anchor) return;
      var handle = findHandle(anchor);
      if (!everydayHandles.has(handle)) return;
      var media = card.querySelector('.product-media');
      if (!media) return;
      var badge = media.querySelector('.jj-everyday-picked-badge');
      var count = selected[handle] || 0;
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'jj-everyday-picked-badge';
          media.style.position = 'relative';
          media.appendChild(badge);
        }
        badge.textContent = '✓ Añadido · ' + count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function renderCart(cart) {
    selected = {};
    var totalEveryday = 0;
    (cart.items || []).forEach(function(item) {
      if (!everydayHandles.has(item.handle)) return;
      var qty = Math.max(0, Number(item.quantity) || 0);
      selected[item.handle] = (selected[item.handle] || 0) + qty;
      totalEveryday += qty;
    });
    var countBadge = document.querySelector('.cart-count');
    if (countBadge || cart.item_count > 0) {
      if (!countBadge) {
        var cartLink = document.querySelector('a[aria-label="Carrito"]');
        if (cartLink) {
          countBadge = document.createElement('span');
          countBadge.className = 'cart-count';
          cartLink.appendChild(countBadge);
        }
      }
      if (countBadge) {
        countBadge.textContent = String(cart.item_count || 0);
        countBadge.hidden = !(cart.item_count > 0);
      }
    }
    updateBadges();
    document.dispatchEvent(new CustomEvent('jj:everyday-cart-updated', { detail: cart }));
    if (!panel) return;
    var thisCount = selected[currentHandle] || 0;
    if (currentStatus) {
      currentStatus.textContent = thisCount > 0
        ? '✓ Añadido al carrito: ' + thisCount + (thisCount === 1 ? ' par de este modelo.' : ' pares de este modelo.')
        : 'Este modelo todavía no está en tu carrito.';
    }
    if (progress) {
      var total = Number(cart.item_count || 0);
      var completed = Math.floor(total / 3);
      var missing = 3 - (total % 3);
      var text = '';
      if (Date.now() > Date.parse('2026-10-31T22:59:59Z')) text = total > 0 ? 'Tienes ' + total + (total === 1 ? ' artículo' : ' artículos') + ' en el carrito.' : 'Todavía no has añadido artículos al carrito.';
      else if (total === 0) text = 'Añade 3 productos de cualquier categoría y paga solo 2.';
      else if (total < 3) text = 'Tienes ' + total + (total === 1 ? ' producto' : ' productos') + '. ¡Añade ' + missing + ' más para tu 3x2!';
      else if (total % 3 === 0) text = '¡' + completed + (completed === 1 ? ' oferta 3x2 completa' : ' ofertas 3x2 completas') + '! El de menor precio sale gratis en cada grupo de tres.';
      else text = '¡Ya tienes ' + completed + (completed === 1 ? ' oferta 3x2' : ' ofertas 3x2') + '! Añade ' + missing + (missing === 1 ? ' producto' : ' productos') + ' más para la siguiente.';
      progress.textContent = text;
    }
    if (button && !busy) {
      button.textContent = thisCount ? 'Añadir otro par de este modelo' : 'Añadir este par al carrito';
    }
  }

  async function fetchCart() {
    var response = await fetch(pathFor('cart.js'), {credentials:'same-origin', headers:{'Accept':'application/json'}});
    if (!response.ok) throw new Error('No se pudo consultar el carrito');
    return await response.json();
  }

  /* Sincroniza los controles de colección con los contadores y la barra de ahorro. */
  document.addEventListener('jj:collection-cart-updated', function (event) {
    if (event.detail && Array.isArray(event.detail.items)) {
      renderCart(event.detail);
    } else {
      fetchCart().then(renderCart).catch(function () {});
    }
  });

  fetchCart().then(renderCart).catch(function() {
    if (progress) progress.textContent = 'Puedes seguir añadiendo pares. Comprueba tu selección al abrir el carrito.';
  });

  if (form && button && everydayHandles.has(currentHandle)) {
    form.addEventListener('submit', async function(event) {
      if (busy) {
        event.preventDefault();
        return;
      }
      var variantField = form.querySelector('[name="id"]');
      if (!variantField || !variantField.value) return;
      event.preventDefault();
      busy = true;
      button.disabled = true;
      button.textContent = 'Añadiendo…';
      try {
        var response = await fetch(pathFor('add.js'), {
          method:'POST',
          credentials:'same-origin',
          headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:new FormData(form)
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'No se ha podido añadir este pendiente.');
        try {
          var cart = await fetchCart();
          busy = false;
          renderCart(cart);
        } catch (refreshErr) {
          busy = false;
          if (currentStatus) currentStatus.textContent = '✓ Pendiente añadido. Puedes comprobarlo en el carrito.';
          if (button) button.textContent = 'Añadir otro par';
        }
      } catch (err) {
        busy = false;
        if (currentStatus) currentStatus.textContent = 'No se añadió: ' + (err.message || 'comprueba el stock y vuelve a intentarlo.');
        if (button) button.textContent = 'Añadir al carrito';
      } finally {
        var select = form.querySelector('[data-jj-earrings-variant-select]');
        var option = select && select.options[select.selectedIndex];
        var available = !option || (option.dataset.available === 'true' && !option.disabled);
        button.disabled = !available;
        button.textContent = (selected[currentHandle] || 0) > 0 ? 'Añadir otro par de este modelo' : 'Añadir este par al carrito';
      }
    });
    var select = form.querySelector('[data-jj-earrings-variant-select]');
    if (select) select.addEventListener('change', function() {
      if (busy || button.disabled) return;
      button.textContent = (selected[currentHandle] || 0) ? 'Añadir otro par de este modelo' : 'Añadir este par al carrito';
    });
  }
});
